export const FILTER_SAVED = 'device/filter_saved';
